<template>
  <page-layout class="article_search">

    <div class="inner">
      <div class="tag">
        <p>Keyword :</p>
        <p class="ctry_kr">{{getKeyword}}</p>
      </div>
    </div>

    <div class="inner">
      <div class="dp_top">
        <display-container :section="95">
          <template v-slot="{ component, row }" class="l_con">
            <div class="img"><img :src="component.getImage(row)"></div>
            <div class="txt">
              <p class="category">{{component.getCate(row)}}</p>
              <p class="subj">{{component.getTitle(row)}}</p>
            </div>
          </template>
        </display-container>
      </div>
    </div>

    <sub-page-layout>

      <div class="title">
        <h3>
          <a href="javascript:" @click="selectedTab = 'articles'"><b :class="selectedTab === 'articles' ? 'text-black' : 'text-grey-6'">Articles<span>({{getSearchArticles.total}})</span></b></a>
          &nbsp;<span class="text-grey-4">|</span>&nbsp;
          <a href="javascript:" @click="selectedTab = 'galleries'"><b :class="selectedTab === 'galleries' ? 'text-black' : 'text-grey-6'">Galleries<span>({{getSearchGalleries.total}})</span></b></a>
        </h3>
        <drop-down v-if="selectedTab === 'articles'" :data="sortOptions" key-name="key" value-name="value" :default-key="sortKey" :action="clickDrowdownRow"></drop-down>
      </div>

      <!-- Article List -->
      <div v-if="selectedTab === 'articles'" :key="1">
        <ul class="lst" id="lst" v-if="getSearchArticles.total > 0">
          <li v-for="(post, index) in queryDataArticles" :key="index" :class="{ 'has_banner': showSubMiddleBanner(index) }"  v-if="post.post_cate !== 33 && post.post_cate !== 34">

            <div v-if="showSubMiddleBanner(index)" class="banner">
              <!--<display-container :section="313" empty-bg-color="transparent">
                <template v-slot="{ component, row }">
                  <img :src="component.getImage(row)" :style="component.getImgSizeByStyle(row)" />
                </template>
              </display-container>-->
              <ins class="adsbygoogle"
               style="display:block"
               data-ad-client="ca-pub-5310971739125617"
               data-ad-slot="1019921057"
               data-ad-format="auto"
               data-full-width-responsive="true"></ins>
            </div>

            <post-container :post="post"></post-container>
          </li>
        </ul>

        <!-- 결과가 없을 경우 -->
        <div class="no_result" v-if="!getSearchArticles.loading && getSearchArticles.total < 1">
          <img src="/statics/img/no_result.jpg">
          <p><i>{{ getKeyword }}</i>에 대한 검색 결과가 없습니다.</p>
        </div>

        <a class="lst_no" v-if="!getSearchArticles.loading && getSearchArticles.total < 1">Did not match any articles</a>
        <a class="lst_more" :disabled="getSearchArticles.loading" v-if="!isSearchArticlesFinish && getSearchArticles.total > 0" @click="getMoreSearchArticles()">Load More Articles</a>
      </div>

      <!-- Gallery List -->
      <div v-else-if="selectedTab === 'galleries'" :key="2">
        <ul class="lst" id="lst" v-if="getSearchGalleries.total > 0">
          <li v-for="(post, index) in queryDataGalleries" :key="index" :class="{ 'has_banner': showSubMiddleBanner(index) }">

            <div v-if="showSubMiddleBanner(index)" class="banner">
              <!--<display-container :section="313" empty-bg-color="transparent">
                <template v-slot="{ component, row }">
                  <img :src="component.getImage(row)" :style="component.getImgSizeByStyle(row)" />
                </template>
              </display-container>-->
              <ins class="adsbygoogle"
                   style="display:block"
                   data-ad-client="ca-pub-5310971739125617"
                   data-ad-slot="1019921057"
                   data-ad-format="auto"
                   data-full-width-responsive="true"></ins>
            </div>

            <post-container :post="post"></post-container>
          </li>
        </ul>

        <!-- 결과가 없을 경우 -->
        <div class="no_result" v-if="!getSearchGalleries.loading && getSearchGalleries.total < 1">
          <img src="/statics/img/no_result.jpg">
          <p><i>{{ getKeyword }}</i>에 대한 검색 결과가 없습니다.</p>
        </div>

        <a class="lst_no" v-if="!getSearchGalleries.loading && getSearchGalleries.total < 1">Did not match any galleries</a>
        <a class="lst_more" :disabled="getSearchGalleries.loading" v-if="!isSearchGalleriesFinish && getSearchGalleries.total > 0" @click="getMoreSearchGalleries()">Load More Galleries</a>
      </div>


    </sub-page-layout>
  </page-layout>
</template>

<script>
  import PageLayout from '../layouts/PageLayout'
  import DisplayContainer from '../components/DisplayContainer'
  import SubPageLayout from '../layouts/SubPageLayout'
  import PostContainer from '../components/PostContainer'
  import DropDown from '../components/Dropdown'
  import CommonMethods from 'src/_mixins/CommonMethods'
  import CommonComputed from 'src/_mixins/CommonComputed'
  import {mapGetters} from 'vuex'
  export default {
    name: 'ArticleSearch',
    components: {
      SubPageLayout,
      PageLayout,
      DisplayContainer,
      PostContainer,
      DropDown,
    },
    metaInfo () {
      return {
        title: `${this.getAppName} 검색 | ${this.getKeyword}`,
        titleTemplate: '%s',
        meta: [
          {vmid: 'description', name: 'description', content: `${this.getKeyword}, ${this.getSearchArticles.total}개 아티클`},
          {vmid: 'image', name: 'image', content: '/statics/seo/seo_main.jpg'},
          {vmid: 'og:title', property: 'og:title', content: `${this.getKeyword} | ${this.getAppName}`},
          {vmid: 'og:description', property: 'og:description', content: `${this.getKeyword}, ${this.getSearchArticles.total}개 아티클`},
          {vmid: 'og:image', property: 'og:image', content: '/statics/seo/seo_main.jpg'}
        ]
      }
    },
    data () {
      return {
        sortKey: 'pub_dt',
        sortOptions: [
          {key: 'pub_dt', value: '최신순'},
          {key: 'view_cnt', value: '인기순'}
        ],
        selectedTab: 'articles'
      }
    },
    created() {
      this.getRouteQuery()
    },
    activated () {
      this.selectedTab = 'articles'
      this.$store.dispatch('callSearchArticles')
      this.$store.dispatch('callSearchGalleries')
    },
    beforeRouteUpdate (to, from, next) {
      if (from.params.keyword !== to.params.keyword) {
        next()
        this.selectedTab = 'articles'
        this.$store.dispatch('callSearchArticles')
        this.$store.dispatch('callSearchGalleries')
      } else {
        next(false)
      }
    },
    computed: {
      ...CommonComputed,
      ...mapGetters([
        'getSearchArticles',
        'isSearchArticlesFinish',
        'getSearchGalleries',
        'isSearchGalleriesFinish',
        'isExistDisplaySubMiddleBanner'
      ]),
      getAccess () {
        return 'pc'
      },
      isMobile () {
        return this.getAccess === 'mobile'
      },
      getKeyword () {
        return this.$route.params.keyword
      },
      queryDataArticles () {
        return this.getSearchArticles.data
          .sort((a, b) => a['idx'] > b['idx'] ? 1 : -1)
          .sort((a, b) => a[this.sortKey] < b[this.sortKey] ? 1 : -1)
      },
      queryDataGalleries () {
        return this.getSearchGalleries.data
          .sort((a, b) => a['idx'] > b['idx'] ? 1 : -1)
          .sort((a, b) => a[this.sortKey] < b[this.sortKey] ? 1 : -1)
      },
    },
    methods: {
      ...CommonMethods,
      getRouteQuery() {
        const query = this.$route.query
        const rtn = this.sortOptions.find(row => row.key === query.sort)
        if (rtn) this.sortKey = query.sort
      },
      getMoreSearchArticles () {
        this.$store.dispatch('loadSearchArticles')
      },
      getMoreSearchGalleries () {
        this.$store.dispatch('loadSearchGalleries')
      },
      clickDrowdownRow (row) {
        this.sortKey = row.key
        this.$router.replace({query: {sort: row.key}})
      },
      showSubMiddleBanner (index) {
        return index > 0 && index%6===0 && this.isMobile && this.isExistDisplaySubMiddleBanner
      },
    }
  }
</script>

<style scoped>
  .tag {
    display: block;
    text-align: center;
    /*border-bottom: 1px solid #000;*/
    padding-bottom: 35px;
  }
  .tag p {
    font-size: 24px;
    font-weight: 500;
    margin-bottom: 5px;
  }
  .tag p.ctry_kr {
    font-family: 'Roboto Slab' ,'SUIT Variable';
    font-size: 60px;
    font-weight: 900;
  }
  .no_result {
    text-align: center;
  }
  .no_result img {
    max-width: 100%;
    padding: 50px;
  }
  .no_result p {
    font-size: 1.6em;
    font-weight: 400;
  }
  .no_result p i {
    font-weight: 700;
  }
</style>
